import React, { useState, useCallback } from "react";
import { FormControl } from 'react-bootstrap';
import { MdOutlineAdd } from "react-icons/md";
import axios from 'axios';
import authHeader from "../services/AuthHeader";
import _ from 'lodash';

const AddCandidate= (props) => {
const initState = {
  ballotCandidateName: '',
  ballotCandidatePartyId: 0,
  ballotId: props.ballotId
};
const [newCandidate, setNewCandidate] = useState(initState);

/* add new candidate */
const addNewCandidate = () => {
   axios
      .post(process.env.REACT_APP_API_BASE + 'ballotCandidate/', newCandidate, {
        headers: authHeader(),
      })
      .then(props.setRerender(true));
      
}

const handleAddCandidate= (evt, name) => {
  debounceCandidates(evt, name);
};

/* debounce until user finished typing */
const debounceCandidates = useCallback(
  
  _.debounce((evt, name) => {
    let value = isNaN(evt.target.value)
      ? evt.target.value
      : parseInt(evt.target.value);
    let temp = newCandidate;
     if (name==='ballotCandidateName') {
      temp['ballotCandidatePartyId'] = 0;
    } 
    temp[name] = value;
    setNewCandidate(temp);
  }, 1000),
  []
);

const ShowAddCandidate = () => {
  return (
    <div>
      <table width='90%'>
        <tr>
          <td>
            <FormControl
              type='textarea'
              placeholder='Add New'
              key={'new_candidate'}
              name={'new_candidate'}
              aria-label='Candidate name'
              style={{ width: '100%' }}
              onChange={(evt) => handleAddCandidate(evt, 'ballotCandidateName')}
            />{' '}
          </td>
          <td>
            <FormControl
              componentClass='select'
              placeholder='select'
              aria-label='Candidate party'
              style={{
                width: '100%',
                marginLeft: '10px',
              }}
              onChange={(evt) =>
                handleAddCandidate(evt, 'ballotCandidatePartyId')
              }
            >
              <option value='0'>Select party</option>
              {props.partyData.map((x) => (
                <option
                  key={x.ballotCandidatePartyId}
                  value={x.ballotCandidatePartyId}
                >
                  {x.ballotCandidatePartyName}
                </option>
              ))}
              <option value='0'>Independent</option>
            </FormControl>
          </td>
          <td>
            <button
              type='button'
              className='icon-button'
              aria-label='Add candidate'
              onClick={() => addNewCandidate()}
            >
              <MdOutlineAdd
                style={{ marginLeft: '20px' }}
                size={40}
                title='add new candidate'
                aria-hidden='true'
              />
            </button>
          </td>
        </tr>
      </table>
    </div>
  );
};

  return (
    <>
      <ShowAddCandidate/>
      </>
  );
}
export default AddCandidate;
